import { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Flex,
  FlexProps,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
} from '@chakra-ui/react';
import { BiUser } from 'react-icons/bi';
import { IoDocumentOutline } from 'react-icons/io5';
import { PiStorefrontDuotone } from 'react-icons/pi';
import { TbReportMoney } from 'react-icons/tb';
import { cpfMask } from '../utils/mask';
import { useSearchParams } from 'react-router-dom';

import cashbackService from '../api/services/cashbackService';

import './styles.sass';

export const Home = (props: FlexProps) => {
  const [applyLoading, setApplyLoading] = useState<boolean>(false);
  const [unity, setUnity] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [document, setDocument] = useState<string>('');
  const [points, setPoints] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [buttonIsVisible, setButtonIsVisible] = useState<boolean>(false);
  const [searchParams] = useSearchParams();

  function converter(valor: string) {
    var numero = parseFloat(valor).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    setPoints(numero);
  }

  const handlechange = (document: any) => {
    setDocument(cpfMask(document));
  };

  const applyCashback = async (
    unity: string,
    name: string,
    userDocument: string,
    points: number | string
  ) => {
    setApplyLoading(true);

    const pointsNumber = parseFloat(
      points.toString().replace('R$', '').replace(' ', '')
    );

    const { status } = await cashbackService.create(
      unity,
      pointsNumber,
      userDocument
    );

    if (status === 400) {
      setMessage(
        'Ocorreu um erro ao tentar resgatar o cashback, tente novamente ou entre em contato com o suporte!'
      );
    } else if (status === 201) {
      setMessage('Cashback resgatado com sucesso!');
      setButtonIsVisible(false);
    }

    setApplyLoading(false);
  };

  useEffect(() => {
    const name = searchParams.get('name');
    const document = searchParams.get('document');
    const points = searchParams.get('points');

    setName(name!);
    handlechange(document!);
    converter(points!);
  }, [searchParams]);

  useEffect(() => {
    if (unity && name && document && points) {
      setButtonIsVisible(true);
    }
  }, [unity, name, document, points]);

  return (
    <Flex as="main" role="main" direction="column" flex="1" py="16" {...props}>
      <Flex maxW="100%" justifyContent="center" flexWrap="wrap">
        <h2 className="title">Valide o cashback aqui</h2>

        <Container className="form" mt={6}>
          <Flex className="input" width="100%">
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                fontSize="1.4em"
                height="100%"
                ml={3}
              >
                <PiStorefrontDuotone color="gray.300" />
              </InputLeftElement>
              <Select
                placeholder="Selecione a unidade"
                size="lg"
                onChange={(e) => setUnity(e.target.value)}
                required
              >
                <option value="MATSUYA MOOCA">MATSUYA MOOCA</option>
                <option value="Matsuya Santana">Matsuya Santana</option>
                <option value="MATSUYA PERDIZES">MATSUYA PERDIZES</option>
                <option value="MATSUYA MORUMBI">MATSUYA MORUMBI</option>
                <option value="Matsuya Panamby">Matsuya Panamby</option>
                <option value="MATSUYA VILA MARIANA">
                  MATSUYA VILA MARIANA
                </option>
                <option value="MATSUYA -ACLIMACAO">MATSUYA -ACLIMACAO</option>
                <option value="MATSUYA MOEMA">MATSUYA MOEMA</option>
                <option value="MATSUYA SAUDE">MATSUYA SAUDE</option>
                <option value="Matsuya Guarulhos">Matsuya Guarulhos</option>
              </Select>
            </InputGroup>
          </Flex>

          <Flex className="input" width="100%" mt={5}>
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                fontSize="1.5em"
                height="100%"
                ml={3}
              >
                <BiUser color="gray.300" />
              </InputLeftElement>
              <Input
                type="text"
                value={name}
                placeholder="Nome do cliente"
                size="lg"
                disabled
              />
            </InputGroup>
          </Flex>

          <Flex className="input" width="100%" mt={5}>
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                fontSize="1.5em"
                height="100%"
                ml={3}
              >
                <IoDocumentOutline color="gray.300" />
              </InputLeftElement>
              <Input
                maxLength={14}
                value={document}
                placeholder="CPF do cliente"
                size="lg"
                disabled
              />
            </InputGroup>
          </Flex>

          <Flex className="input" width="100%" mt={5}>
            <InputGroup>
              <InputLeftElement
                pointerEvents="none"
                fontSize="1.5em"
                height="100%"
                ml={3}
              >
                <TbReportMoney color="gray.300" />
              </InputLeftElement>
              <Input
                type="text"
                maxLength={14}
                value={points}
                placeholder="Valor a ser resgatado"
                size="lg"
                onChange={(e: any) => setPoints(e.target.value)}
                disabled
              />
            </InputGroup>
          </Flex>

          <Flex
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            flexWrap="wrap"
            mt={6}
          >
            <h2 className="return">{message}</h2>
            {buttonIsVisible && unity && name && document && points && (
              <Flex w="100%" justify="center" mt={4}>
                <Button
                  isLoading={applyLoading}
                  width="48%"
                  size="lg"
                  loadingText="Resgatando cashback..."
                  colorScheme="teal"
                  onClick={() => applyCashback(unity, name, document, points)}
                >
                  Resgatar cashback
                </Button>
              </Flex>
            )}
          </Flex>
        </Container>
      </Flex>
    </Flex>
  );
};
